"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

require("./search-recommendation.css");

var _constants = require("../constants");

var _helperUtils = require("../utils/helperUtils");

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !_construct.default) return false;
    if (_construct.default.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call((0, _construct.default)(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = (0, _construct.default)(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var SearchRecommendation = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(SearchRecommendation, _React$Component);

  var _super = _createSuper2(SearchRecommendation);

  function SearchRecommendation() {
    var _this;

    (0, _classCallCheck2.default)(this, SearchRecommendation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleRecommendationClick", function () {
      if (typeof window !== 'undefined') {
        document.location.href = "".concat(_this.props.targetUrl || '#', "?intpr=sitesearch_recommended");
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateCursor", function () {
      _this.props.onMouseEnter(_this.props.index);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resetCursor", function () {
      _this.props.onMouseLeave(-1);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSearchRecommendationItemKeyDown", function (e) {
      if ((0, _helperUtils.filterKeyPress)(e, [_helperUtils.keyCodeMap.enter])) {
        _this.handleRecommendationClick();
      } else {
        _this.props.onKeyDown(e);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(SearchRecommendation, [{
    key: "render",
    value: function render() {
      var index = this.props.index;
      return _react.default.createElement("li", {
        className: 'recommendation-item',
        ref: this.myRef,
        onKeyDown: this.onSearchRecommendationItemKeyDown,
        onMouseEnter: this.updateCursor,
        onMouseLeave: this.resetCursor
      }, _react.default.createElement("a", {
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: "0",
        onClick: this.handleRecommendationClick,
        "aria-label": "".concat(_constants.RECOMMENDED, ":").concat(this.props.label) // {...getLinkTrackingAttr(this.props.label, this.props.index)}
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        ,
        role: "option",
        id: "option-".concat(index),
        className: "".concat(this.props.index === this.props.cursor ? 'focus' : '')
      }, _react.default.createElement("div", {
        className: "image-container",
        style: {
          backgroundImage: "url(".concat(this.props.imageUrl, ")")
        }
      }), _react.default.createElement("div", {
        className: "details"
      }, _react.default.createElement("div", {
        className: "item-label"
      }, this.props.label), this.props.description ? _react.default.createElement("p", {
        className: "description"
      }, this.props.description) : null)));
    }
  }]);
  return SearchRecommendation;
}(_react.default.Component);

exports.default = SearchRecommendation;
(0, _defineProperty2.default)(SearchRecommendation, "propTypes", {
  imageUrl: _propTypes.default.string,
  label: _propTypes.default.string,
  description: _propTypes.default.string,
  targetUrl: _propTypes.default.string,
  cursor: _propTypes.default.number,
  onKeyDown: _propTypes.default.func,
  index: _propTypes.default.number,
  onMouseEnter: _propTypes.default.func,
  onMouseLeave: _propTypes.default.func
});
(0, _defineProperty2.default)(SearchRecommendation, "defaultProps", {
  imageUrl: '',
  label: '',
  description: '',
  targetUrl: '',
  onKeyDown: function onKeyDown() {}
});